export default "__VITE_ASSET__y37Htpui__"